import React from "react";
import { Outlet } from "react-router-dom";
import SignInPage from "@pages/Auth/SignInPage";
import SignUpPage from "@pages/Auth/SignUpPage";
import ResetPasswordPage from "@pages/Auth/ResetPasswordPage";
import ForgotPasswordPage from "@pages/Auth/ForgotPasswordPage";
import ResetConfirmationPage from "@pages/Auth/ResetConfirmationPage";
import ResetRequestConfirmationPage from "@pages/Auth/ResetRequestConfirmationPage";
import AcceptBusinessInvitePage from "@pages/Auth/AcceptBusinessInvitePage";
import SignUpSuccessPage from "@pages/Auth/SignUpSuccessPage";
import VerifyEmailPage from "@pages/Auth/VerifyEmailPage";

export default [
    {
        path: "auth",
        element: <Outlet />,
        children: [
            {
                path: "sign-in",
                element: <SignInPage />,
            },
            {
                path: "sign-up",
                element: <SignUpPage />,
            },
            {
                path: "sign-up-success",
                element: <SignUpSuccessPage />,
            },
            {
                path: "verify-email",
                element: <VerifyEmailPage />,
            },
            {
                path: "forgot-password",
                element: <ForgotPasswordPage />,
            },
            {
                path: "reset-password",
                element: <ResetPasswordPage />,
            },
            {
                path: "reset-confirmation",
                element: <ResetConfirmationPage />,
            },
            {
                path: "reset-request-confirmation",
                element: <ResetRequestConfirmationPage />,
            },
            {
                path: "accept-business-invite",
                element: <AcceptBusinessInvitePage />,
            },
        ],
    },
];
